import { defineStore } from 'pinia'


export const useSiteConfigStore = defineStore('siteConfig', {
  state: () => ({
    profile: 'fr',
    schoolId: "6",
    languageName: '法语',
    siteName: "欧那法语",
    cookieDomain: `fr.olacio.com`,
    ApiDomainName: 'http://fr.rc.olacio.com',
    
    // API 端点
    config: {
      tmainCode: 'https://tmains.example.com/de/xxxxxxxxxxxxxxxxx/sdfs.js',
      baiduTongjiCode: "UA-XXXXXXXX-X",
      baiduTongjiJs: "https://hm.baidu.com/hm.js?dexxxxxxxxxxxxxxxxxxxxxxxxxxxxxx",
      weixinAppId:'wx7227aeda3533cb89'
    },
    
    // 特性开关   
    features: {
      onlineBooking: true,
      freeTrial: true,
      certificateProgram: true,
      quotationMenu: true
    },
    // 主题配置
    theme: {
      primaryColor: '#3b82f6',
      secondaryColor: '#10b981',
      logo: '/resources/en/images/logo-en.svg'
    },
    // 本地化内容
    content: {
      welcomeMessage: 'Welcome to our English training program!',
    },
    
    // 导航菜单配置
    navigation: [],
    
    /**
     * Header 主题色（可配置）
     * - 默认值：#FF1F59
     * - 德国站：#F93636
     */
    headerMainColor: '#FF1F59',
    
    // 友情链接配置
    friendlyLinks: [],
    //
    footerLinks: [],
    customerService:{}
  }),
  actions: {
    setConfig(config) {
      this.$patch(config)
    }
  }
})
